const updateShowingCount = (resp) => {
  // Get new "count of total" markup
  const newShowingTotalHtml = new DOMParser()
    .parseFromString(resp, 'text/html')
    .querySelector('[data-showing-count]').innerHTML;

  // Render "count of total" markup
  const newShowingTotalElem = document.querySelector('[data-showing-count]');
  newShowingTotalElem.innerHTML = newShowingTotalHtml;
};

export default updateShowingCount;
